import { render, staticRenderFns } from "./marketing-lists-contacts-choice.vue?vue&type=template&id=062db792"
import script from "./marketing-lists-contacts-choice.vue?vue&type=script&lang=js"
export * from "./marketing-lists-contacts-choice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports